__turbopack_context__.v({
  "axis": "PcMD1W_axis",
  "bar": "PcMD1W_bar",
  "counter": "PcMD1W_counter",
  "labels": "PcMD1W_labels",
  "monthLabel": "PcMD1W_monthLabel",
  "pct": "PcMD1W_pct",
  "plot": "PcMD1W_plot",
  "root": "PcMD1W_root",
});
